import cx from 'classnames';
import PropTypes from 'prop-types';

import NotificationSuccess from 'src/assets/icons/NotificationSuccess';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  compliantFormats: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    })
  ).isRequired,
};

const defaultProps = {
  className: null,
  classes: null,
};

export const FormatCompliantFormats = ({ className, classes, compliantFormats }) => {
  const styles = useStyles({ classes });

  if (!compliantFormats.length) {
    return null;
  }

  return (
    <div className={cx(styles.root, className)}>
      <CustomTypography
        className={styles.sectionTitle}
        variant={TYPOGRAPHY_VARIANT.medium14}
      >
        Compliant Formats
      </CustomTypography>
      <div className={styles.formatsList}>
        {compliantFormats.map((format, index) => (
          <div
            key={`${format.type}-${index}`}
            className={styles.compliantBox}
          >
            <NotificationSuccess className={styles.checkmarkIcon} />
            <CustomTypography
              className={styles.formatText}
              variant={TYPOGRAPHY_VARIANT.regular14}
            >
              This text complies with {format.name}.
            </CustomTypography>
          </div>
        ))}
      </div>
    </div>
  );
};

FormatCompliantFormats.propTypes = propTypes;
FormatCompliantFormats.defaultProps = defaultProps;
